import React from "react";
import "../../styles/dashboard.css";
import { Table } from "react-bootstrap";
import { LuExternalLink } from "react-icons/lu";

const SourceAssetTable = ({ sourceAsset, showPurpleWaveIcn }) => {
  return (
    <>
      <div className="table-scroll">
        <Table className="table-backgorund">
          <thead className="table-head">
            <tr>
              <th>Year</th>
              <th>Make</th>
              <th>Model</th>
              {showPurpleWaveIcn && <th>ICN</th>}
              <th>Site Link</th>
            </tr>
          </thead>
          <tbody>
            <div style={{ marginBottom: "0.5rem" }}></div>
            <tr className="deal">
              <td>{sourceAsset?.year || "N/A"}</td>
              <td>{sourceAsset?.make || "N/A"}</td>
              <td>{sourceAsset?.model || "N/A"}</td>
              {showPurpleWaveIcn && <td>{sourceAsset?.purple_wave_icn || "N/A"}</td>}
              <td>
                {sourceAsset?.equipment_url ? (
                  <a
                    href={sourceAsset?.equipment_url}
                    target="_blank"
                    rel="noreferrer"
                    className="link-review"
                    style={{ display: "inline-flex", alignItems: "center", gap: "6px", textDecoration: "none" }}
                  >
                    <LuExternalLink /> Open
                  </a>
                ) : (
                  "N/A"
                )}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default SourceAssetTable;
